import { WrappedMultiInput } from "components/form/MultiInput";
import TextAreaField from "components/form/TextAreaField";
import { validateName, validateEmail, validateMultiInput } from "../../../.././../../common/utils/validators";

const fieldRepository = {
  name: {
    name: "name",
    type: "text",
    required: true,
    label: "Name",
    placeholder: "Full name",
    validator: validateName,
    formatValue: (val) => {
      val.trim();
      val = val.replace(/\s\s+/g, " ");

      return val;
    },
    defaultValue: (customer) => customer.name,
  },
  email: {
    name: 'email',
    type: 'text',
    required: true,
    label: 'Email',
    placeholder: 'Email id',
    validator: validateEmail,
    formatValue: (val) => val.trim(),
    defaultValue: (customer) => customer.email
  },
  guest_emails: {
    name: 'guest_emails',
    type: 'text',
    required: false,
    placeholder: 'guest1@gmail.com, guest2@gmail.com',
    validator: (value) => {
      return validateMultiInput(value, validateEmail); 
    },
    formatValue: (val) => val.trim(),
    customErrorDescription: "Please enter valid emails.",
    _componentLabel: 'Add Guests',
    _component: WrappedMultiInput,
  },
  agenda: {
    name: 'agenda',
    type: 'text',
    required: false,
    label: 'Notes',
    placeholder: 'Please share anything that will help prepare for our meeting.',
    _component: TextAreaField,
  }
};

export default fieldRepository;
